// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { Ticket, ticketSchema } from '@/ticket/api/types';
import { z } from 'zod';

export const getTicketRequestSchema = z.object({
  key: z.string(),
});

type GetTicketRequest = z.infer<typeof getTicketRequestSchema>;

const getTicketResponseSchema = z.object({
  data: ticketSchema,
});

/**
 * Get a ticket by key
 */
export async function getTicket(request: GetTicketRequest): Promise<Ticket> {
  const url = `/v1/ticket/${request.key}`;
  const response = await api.get(url);
  const parsed = await parseResponse(getTicketResponseSchema, response.data, {
    schemaName: 'Ticket',
    endpoint: url,
  });
  return parsed.data;
}
